import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ALertOption } from 'src/app/Models/alert/alert-option';

import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { LoadingComponent } from '../objects/loading/loading.component';
import { NothingComponent } from '../objects/nothing/nothing.component';
import { AddUbicacionComponent } from './add-ubicacion/add-ubicacion.component';


@Component({
  selector: 'app-ubicacion',
  templateUrl: './ubicacion.component.html',
  styleUrls: ['./ubicacion.component.css']
})
export class UbicacionComponent implements OnInit {

  @ViewChild(AddUbicacionComponent, null) newubicacion: AddUbicacionComponent;
    @ViewChild(LoadingComponent, null) public loading: LoadingComponent;
    @ViewChild(NothingComponent, null) public nothing: NothingComponent;
    public busqueda: string = '';
    public usuario: any;
    public listaubicaciones: any[] = [];
    public total: number = 0;
    public pgcliente: any;
    constructor(private title: Title, private data: DataService, private auth: AuthService) { }
  
    ngOnInit() {
      this.title.setTitle('Ubicaciones | Sistema de ventas');
      this.usuario = this.auth.getCurrentUser();
      this.GetUbicacion()
    }
  
  
    GetUbicacion() {
      this.loading.show('cargando datos');
      this.listaubicaciones = [];
  
      this.data.GetSimple(this.data.api.ubicacion).subscribe(r => {
        this.loading.hide();
        if (this.data.Exists(r)) {
          console.log(r);
  
          this.listaubicaciones = r;
          this.total = this.listaubicaciones.length;
        } else { this.listaubicaciones = []; this.total = 0; }
      }, e => { console.log(e.error.text) });
    }
  
    busquedaubicacion() {
      this.loading.show('cargando datos');
      this.listaubicaciones = [];
  
      this.data.GetFromId('search_ubicacion', this.busqueda).subscribe(r => {
        this.loading.hide();
        if (this.data.Exists(r)) {
          console.log(r);
  
          this.listaubicaciones = r;
          this.total = this.listaubicaciones.length;
        } else { this.listaubicaciones = []; this.total = 0; }
      }, e => { console.log(e.error.text) });
    }
  
    SearchUbicacion() {
      if (this.busqueda != '') {
        this.busquedaubicacion();
      } else {
        this.GetUbicacion();
      }
    }
  
    AddUbicacion() {
      this.newubicacion.ubicacion = {};
      this.newubicacion.isedit = false;
      this.newubicacion.show(() => {
        this.GetUbicacion();
      });
    }
  
    EditUbicacion(ubicacion:any) {
      this.newubicacion.ubicacion = ubicacion; 
      this.newubicacion.isedit = true;
      this.newubicacion.show(() => {
        this.GetUbicacion();
      });
    }
  
    DeleteUbicacion(ubicacion:any) {
      console.log("Info de ubicacion",ubicacion);
      let options = new ALertOption()
      options.showCancelButton = true;
      this.data.notify("Desea eliminar esta categoria?","Atencion",this.data.alertType.warning,options,() => {
        this.newubicacion.EliminarUbicacion(ubicacion.idubicacion).subscribe(
          (res)=>{
            this.data.notify("Categoria eliminada","Exito",this.data.alertType.success,options=new ALertOption(),()=>{this.GetUbicacion()});
            
          },
          (error)=>{}
        )
      },()=>{console.log("eliminacion cancelada");
      })
    }

}
